/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import {
  faChevronDown,
  faChevronUp,
  faHistory,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
// import { useDispatch } from "react-redux"

import { Link, useHistory, useLocation } from "react-router-dom"
import { AppDispatch } from "../../.."
// import { AppDispatch } from "../.."
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import TextInput from "../../../components/InputWrapper/TextInput"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import {
  clearAlert,
  setAlerts,
  setWarningAlerts,
} from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import BihinzaikoService from "../../../service/purchase/bihinzaiko/bihinzaikoService"
import {
  TBihinzaikoInfoGetRes,
  TBihinzaikoListGetReq,
  備品在庫管理,
} from "../../../service/purchase/bihinzaiko/TBihinzaiko"

import { 購買管理メニューコード } from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { TWijmoCellTemplateContext } from "../../../type/wijmoComponents"
import { faPlusSquare } from "@fortawesome/free-regular-svg-icons"
import EmptyTextHeader from "../../../components/FlexGridWrapper/EmptyTextHeader"
import ConfirmModal from "../../../components/Modal/ConfirmModal"
import { RootState } from "../../../globalStore/rootreducer"
import { TApiResponse } from "../../../service/TApiResponse"
import { showInfoToast } from "../../../components/CustomToast"
import kengenUtil from "../../../ts/util/kengenUtil"

/**
 * 備品在庫一覧
 * @returns
 */
const PurchaseBihinzaikoList = () => {
  const history = useHistory()
  const location = useLocation()
  const disPatch: AppDispatch = useDispatch()

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "PurchaseBihinzaikoList_GridId"

  // 権限制御
  const userInfo = useSelector(
    (rootState: RootState) => rootState.user.LoginUserInfo
  )
  const 読取り専用フラグ = kengenUtil.備品在庫削除ボタンの権限判定(userInfo)

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (
    data: Array<TBihinzaikoInfoGetRes>,
    pageSize: number
  ) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  const beforeSubmit = () => {
    // TODO:バリデーションチェック

    setIsConfirmDeleteModalShow(true)
  }

  //TODO:PUTのみAPIで処理
  const submit = async () => {
    try {
      const service = new BihinzaikoService()

      let res: TApiResponse<boolean>

      let data = {
        更新日時: 削除対象!.更新日時,
      }

      res = await service.bihinDelete(削除対象!.備品在庫ID.toString(), data)

      disPatch(setAlerts(res))
      if (res) {
        showInfoToast(
          `${削除対象!.備品在庫ID.toString()}の削除が完了しました。`
        )
        const querySearchCondition = queryParse()
        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      }
    } catch (error) {
      disPatch(setAlerts(error))
    } finally {
      setIsConfirmDeleteModalShow(false)
    }
  }

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TBihinzaikoListGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBihinzaikoListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new BihinzaikoService().getList(currentSearchCondition)

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      // dispatch(setAlerts(error))
      dispatch(setWarningAlerts(["エラー表示"]))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBihinzaikoListGetReq = queryString.parse(location.search)
    set備品名(query.備品名)
    set備品コード(query.備品コード)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBihinzaikoListGetReq => {
    return {
      備品名: 備品名 ?? undefined,
      備品コード: 備品コード ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBihinzaikoListGetReq
  ) => {
    return {
      備品名: wjCore.isNullOrWhiteSpace(searchCondition.備品名 ?? "")
        ? ""
        : searchCondition.備品名,
      備品コード: wjCore.isNullOrWhiteSpace(searchCondition.備品コード ?? "")
        ? ""
        : searchCondition.備品コード,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set備品名("")
    set備品コード("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(10)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  // modal
  const [isConfirmDeleteModalShow, setIsConfirmDeleteModalShow] =
    useState(false)
  const [削除対象, set削除対象] = useState<TBihinzaikoInfoGetRes>()
  //#endregion

  //#region [state]

  const [備品名, set備品名] = useState<string>()
  const [備品コード, set備品コード] = useState<string>()
  const [mode, setMode] = useState<string>("")

  //#endregion

  //#region [effect]

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    // URLの末尾を取得
    let stringArray = location.pathname.split("/")
    let sMode = stringArray[stringArray.length - 1]
    setMode(sMode)

    // 受入払出切り替え情報設定
    let sTitle = ""
    if (備品在庫管理.受入.toString() === sMode) {
      sTitle = "備品在庫一覧（購買部）"
    } else {
      sTitle = "備品在庫一覧（車輌部）"
    }
    document.title = sTitle

    // タグ書き換え
    const getTitleRect = document.getElementById("spanTitle")
    const getNewButtonRect = document.getElementById("divNewButton")
    if (getTitleRect != null) {
      getTitleRect.innerText = sTitle
    }
    if (getNewButtonRect != null && 備品在庫管理.払出.toString() === sMode) {
      getNewButtonRect.remove()
    }

    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])

  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span id="spanTitle" className="page-title"></span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-60rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body id="collapse-search-card-body">
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <ul className="list-cmn d-flex">
                          <li className="list-cmn">
                            <div className="d-flex">
                              <TextInput
                                autoFocus
                                id="備品名"
                                name="備品名"
                                value={備品名}
                                setValue={set備品名}
                                maxLength={100}
                                placeholder="備品名"
                              />
                              <TextInput
                                id="備品コード"
                                name="備品コード"
                                value={備品コード}
                                setValue={set備品コード}
                                maxLength={15}
                                placeholder="備品コード"
                              />
                            </div>
                          </li>
                        </ul>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={gridId}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                headerComponent={
                  <Row>
                    <Col xl={{ span: "auto", offset: 0 }} id="divNewButton">
                      <div>
                        <Link
                          to={
                            util.getMenuPath(
                              購買管理メニューコード.備品在庫受入登録
                            )[0]
                          }
                          onClick={() =>
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                          }>
                          <Button disabled={isSearching}>
                            <FontAwesomeIcon icon={faPlusSquare} />
                            新規受入
                          </Button>
                        </Link>
                      </div>
                    </Col>
                    <Col xl={{ span: "auto", offset: 0 }} id="divRirekiButton">
                      <div>
                        <Link
                          to={
                            備品在庫管理.受入.toString() === mode.toString()
                              ? util.getMenuPath(
                                  購買管理メニューコード.備品在庫受入履歴一覧
                                )[0]
                              : util.getMenuPath(
                                  購買管理メニューコード.備品在庫払出履歴一覧
                                )[0]
                          }
                          onClick={() =>
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )
                          }>
                          <Button disabled={isSearching}>
                            <FontAwesomeIcon icon={faHistory} />
                            備品在庫
                            {備品在庫管理.受入.toString() === mode.toString()
                              ? "受入"
                              : "払出"}
                            履歴
                          </Button>
                        </Link>
                      </div>
                    </Col>
                  </Row>
                }>
                <wjrGrid.FlexGridColumn
                  header=""
                  allowMerging="true"
                  align="center"
                  width={100}
                  selectable={false}
                  isReadOnly>
                  <wjrGrid.FlexGridCellTemplate
                    cellType="Cell"
                    template={(
                      context: TWijmoCellTemplateContext<TBihinzaikoInfoGetRes>
                    ) => {
                      // 備品在庫受入・払出登録
                      let url = util.getMenuPath(
                        購買管理メニューコード.備品在庫受入登録
                      )[1]
                      if (備品在庫管理.払出.toString() === mode.toString()) {
                        url = util.getMenuPath(
                          購買管理メニューコード.備品在庫払出登録
                        )[1]
                      }
                      return (
                        <Button
                          className="btn btn-small btn-primary move-edit-page"
                          onClick={() => {
                            // 画面全体のスクロール位置の保存
                            gridPageHelper.savePageConditionData(
                              location.pathname
                            )

                            history.push(
                              url.replaceAll(
                                ":id",
                                context.item.備品在庫ID.toString()
                              )
                            )
                          }}>
                          {備品在庫管理.受入.toString() === mode.toString()
                            ? "在庫受入"
                            : "在庫払出"}
                        </Button>
                      )
                    }}
                  />
                </wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備品コード"
                  width={110}
                  header="備品CD"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="備品名"
                  width={250}
                  header="備品名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="サイズ"
                  width={100}
                  header="サイズ"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="単位"
                  width={100}
                  align="right"
                  header="単位"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="ロット"
                  width={150}
                  align="right"
                  header="ロット"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="払出単価"
                  width={100}
                  header="払出単価"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="在庫数量"
                  width={100}
                  align="right"
                  header="在庫数量"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="在庫場所"
                  width={240}
                  header="在庫場所"></wjrGrid.FlexGridColumn>
                {備品在庫管理.受入.toString() === mode.toString() && (
                  <wjrGrid.FlexGridColumn
                    binding="備考"
                    width={300}
                    header="備考"></wjrGrid.FlexGridColumn>
                )}
                {/* 権限により削除ボタンを表示 */}
                {読取り専用フラグ &&
                  備品在庫管理.受入.toString() === mode.toString() && (
                    <wjrGrid.FlexGridColumn
                      header="削除"
                      allowDragging={false}
                      align="center"
                      width={100}
                      selectable={false}
                      isReadOnly>
                      <EmptyTextHeader></EmptyTextHeader>
                      <wjrGrid.FlexGridCellTemplate
                        cellType="Cell"
                        template={(
                          context: TWijmoCellTemplateContext<TBihinzaikoInfoGetRes>
                        ) => {
                          return (
                            <Button
                              className="btn btn-small btn-primary move-edit-page"
                              variant="caution"
                              onClick={(e) => {
                                e.stopPropagation()
                                e.preventDefault()
                                set削除対象(context.item)
                                beforeSubmit()
                              }}>
                              削除
                            </Button>
                          )
                        }}
                      />
                    </wjrGrid.FlexGridColumn>
                  )}
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {/* 削除確認 */}
      <ConfirmModal
        isShow={isConfirmDeleteModalShow}
        hideHandler={setIsConfirmDeleteModalShow}
        submitHandler={submit}>
        備品CD:{削除対象?.備品コード}を削除しますか？
      </ConfirmModal>
    </Container>
  )
}
export default PurchaseBihinzaikoList
